// Dữ liệu module Công việc (dùng chung cho Danh sách công việc và Dashboard).
// Khi nối API: thay seedTasks() bằng dữ liệu từ server theo đúng shape WorkTask.
import dayjs from 'dayjs';
import { TEMPLATES } from './templates';

/** todo: chưa bắt đầu · doing: đang làm · review: đã báo xong, chờ người giao duyệt · done: hoàn thành
 *  failed: đóng lại vì không đạt · cancelled: huỷ (không tính vào báo cáo) */
export type TaskStatus = 'todo' | 'doing' | 'review' | 'done' | 'failed' | 'cancelled';

export interface Department { id: string; name: string }
export interface Project { id: string; name: string; departmentId: string; type: 'project' | 'team' }
export interface Member { id: string; name: string; departmentId: string; color: string; manager?: 'all' | 'department' }

export type ActivityType = 'create' | 'assign' | 'start' | 'submit' | 'approve' | 'return' | 'due' | 'fail' | 'cancel' | 'reopen' | 'comment' | 'edit';

/** photos: ảnh kết quả đính kèm khi báo xong (data URL đã nén) */
export interface TaskActivity { id: string; at: string; by: string; type: ActivityType; text?: string; photos?: string[] }

/** Việc định kỳ: đóng lần này thì tự tạo lần kế tiếp (khử khuẩn hằng ngày, bảo trì máy hằng tháng…) */
export type Repeat = 'daily' | 'weekly' | 'monthly';
export const REPEAT_LABEL: Record<Repeat, string> = { daily: 'Hằng ngày', weekly: 'Hằng tuần', monthly: 'Hằng tháng' };

/** Mục checklist quy trình: ai tích, lúc nào — phục vụ hậu kiểm */
export interface CheckItem { id: string; text: string; done?: boolean; by?: string; at?: string }

export interface WorkTask {
  id: string;
  code: string;
  name: string;
  description?: string;
  projectId: string;
  departmentId: string;
  parentId?: string; // có giá trị = công việc con
  creatorId: string; // người giao việc, cũng là người duyệt kết quả
  assigneeId?: string; // trống = chưa giao
  followerIds: string[];
  createdAt: string; // YYYY-MM-DD
  startAt?: string;
  dueAt?: string; // trống = không có hạn chót
  submittedAt?: string; // ngày người làm báo xong
  doneAt?: string; // ngày hoàn thành (= ngày báo xong nếu phải duyệt) — dùng để tính đúng hạn / muộn
  status: TaskStatus;
  important: boolean;
  urgent: boolean;
  needReview: boolean;
  checklist?: CheckItem[]; // phải tích đủ mới báo hoàn thành được
  needProof?: boolean; // báo xong phải kèm ảnh kết quả
  repeat?: Repeat;
  seriesId?: string; // các lần của cùng một việc định kỳ
  repeatDay?: number; // việc hằng tháng: ngày trong tháng của lần đầu (lần sau tháng ngắn hơn thì lùi tạm, tháng sau trở lại)
  templateId?: string; // tạo từ mẫu quy trình nào
  activity: TaskActivity[];
}

export const DEPARTMENTS: Department[] = [
  { id: 'd-cm', name: 'Chuyên môn – Bác sĩ' },
  { id: 'd-dd', name: 'Điều dưỡng – KTV' },
  { id: 'd-lt', name: 'Lễ tân' },
  { id: 'd-vh', name: 'Vận hành cơ sở' },
  { id: 'd-kho', name: 'Kho – Dược' },
  { id: 'd-cskh', name: 'Chăm sóc khách hàng' },
  { id: 'd-tele', name: 'Telesales' },
  { id: 'd-mkt', name: 'Marketing' },
  { id: 'd-kt', name: 'Kế toán' },
  { id: 'd-hc', name: 'Tổ chức - Hành chính' },
  { id: 'd-it', name: 'Công nghệ' },
];

export const PROJECTS: Project[] = [
  ...DEPARTMENTS.map(d => ({ id: `t-${d.id}`, name: `Phòng ${d.name}`, departmentId: d.id, type: 'team' as const })),
  { id: 'p-hk', name: 'Chuẩn bị hậu kiểm Sở Y tế', departmentId: 'd-cm', type: 'project' },
  { id: 'p-bf', name: 'Chiến dịch Black Friday', departmentId: 'd-mkt', type: 'project' },
  { id: 'p-tele', name: 'Báo cáo kết quả Telesales tuần', departmentId: 'd-tele', type: 'project' },
  { id: 'p-lt', name: 'Chuẩn hoá quy trình liệu trình', departmentId: 'd-cm', type: 'project' },
  { id: 'p-cms', name: 'Triển khai CMS v2', departmentId: 'd-it', type: 'project' },
  { id: 'p-ktv', name: 'Đào tạo KTV quý 4', departmentId: 'd-dd', type: 'project' },
];

/** Người đang đăng nhập — demo coi là quản lý (được duyệt / điều chỉnh mọi việc) */
export const ME_ID = 'me';

const readMyName = () => {
  try {
    const u = JSON.parse(localStorage.getItem('user') || '{}');
    return u.fullname || u.name || u.info?.fullname || 'Tôi';
  } catch {
    return 'Tôi';
  }
};

export const MEMBERS: Member[] = [
  { id: ME_ID, name: readMyName(), departmentId: 'd-it', color: '#3e91ab', manager: 'all' },
  { id: 'm1', name: 'Nguyễn Quách Thùy Linh', departmentId: 'd-hc', color: '#f59e0b', manager: 'department' },
  { id: 'm2', name: 'Hồ Văn Hoàng', departmentId: 'd-it', color: '#10b981' },
  { id: 'm3', name: 'Phạm Thuý Vy', departmentId: 'd-mkt', color: '#ec4899', manager: 'department' },
  { id: 'm4', name: 'Phan Yến', departmentId: 'd-tele', color: '#f97316', manager: 'department' },
  { id: 'm5', name: 'Đỗ Hồ Phương Thảo', departmentId: 'd-cskh', color: '#0ea5e9', manager: 'department' },
  { id: 'm6', name: 'Nguyễn Hoàng My', departmentId: 'd-kt', color: '#6366f1', manager: 'department' },
  { id: 'm7', name: 'Trương Minh Ngọc', departmentId: 'd-vh', color: '#eab308', manager: 'department' },
  { id: 'm8', name: 'Thuỳ Ny', departmentId: 'd-vh', color: '#64748b' },
  { id: 'm9', name: 'Trần Tuấn Anh Nghĩa', departmentId: 'd-it', color: '#3b82f6' },
  { id: 'm10', name: 'Lâm Thị Bảo Uyên', departmentId: 'd-mkt', color: '#14b8a6' },
  { id: 'm11', name: 'Nguyễn Thị Ngọc Lan', departmentId: 'd-cskh', color: '#22c55e' },
  { id: 'm12', name: 'Võ Minh Khang', departmentId: 'd-tele', color: '#a855f7' },
  { id: 'm13', name: 'Lê Thanh Hằng', departmentId: 'd-kt', color: '#ef4444' },
  { id: 'm14', name: 'Bùi Quốc Bảo', departmentId: 'd-hc', color: '#0891b2' },
  { id: 'm15', name: 'BS. Nguyễn Minh Tâm', departmentId: 'd-cm', color: '#be123c', manager: 'department' },
  { id: 'm16', name: 'BS. Lê Hoàng Phúc', departmentId: 'd-cm', color: '#7c3aed' },
  { id: 'm17', name: 'Trần Thị Mai', departmentId: 'd-dd', color: '#0d9488', manager: 'department' },
  { id: 'm18', name: 'Phạm Ngọc Hân', departmentId: 'd-dd', color: '#db2777' },
  { id: 'm19', name: 'Đặng Thu Trang', departmentId: 'd-lt', color: '#ea580c', manager: 'department' },
  { id: 'm20', name: 'Huỳnh Gia Bảo', departmentId: 'd-kho', color: '#4d7c0f', manager: 'department' },
];

const TASK_NAMES: Record<string, string[]> = {
  'd-cm': ['Hội chẩn ca khó trong tuần', 'Duyệt phác đồ điều trị mới', 'Rà soát hồ sơ bệnh án tháng', 'Đánh giá ca biến chứng sau thủ thuật', 'Cập nhật hướng dẫn chăm sóc sau tiêm filler', 'Kiểm tra tay nghề KTV'],
  'd-dd': ['Chuẩn bị dụng cụ ca thủ thuật', 'Hấp tiệt trùng dụng cụ', 'Bổ sung vật tư phòng thủ thuật', 'Ghi sổ theo dõi tiệt khuẩn', 'Hướng dẫn khách chăm sóc sau liệu trình'],
  'd-lt': ['Xác nhận lịch hẹn ngày mai', 'Sắp xếp phòng chờ VIP', 'Cập nhật bảng giá tại quầy', 'Tổng hợp khách đến trễ hẹn', 'Hướng dẫn khách ký cam kết thủ thuật'],
  'd-kho': ['Kiểm kê tủ thuốc', 'Nhập lô filler mới', 'Đối chiếu tồn kho với POS', 'Lập dự trù vật tư tháng', 'Kiểm tra tồn kho mỹ phẩm'],
  'd-hc': ['Cập nhật hồ sơ nhân sự mới', 'Lên lịch đào tạo nội quy', 'Soạn quyết định bổ nhiệm', 'Kiểm kê tài sản văn phòng', 'Chấm công và tổng hợp ngày phép', 'Tuyển dụng điều dưỡng, KTV', 'Đặt đồng phục nhân viên'],
  'd-kt': ['Đối soát doanh thu POS', 'Lập báo cáo thuế tháng', 'Thanh toán công nợ nhà cung cấp', 'Đối chiếu công nợ thẻ liệu trình', 'Tính lương và hoa hồng', 'Kiểm tra hoá đơn đầu vào'],
  'd-mkt': ['Thiết kế banner khuyến mãi', 'Viết bài Facebook', 'Quay video before/after', 'Chạy quảng cáo TikTok', 'Lên kế hoạch KOL', 'Báo cáo hiệu quả chiến dịch', 'Cập nhật landing page'],
  'd-tele': ['Gọi lại khách chưa chốt', 'Tổng hợp data khách mới', 'Báo cáo tỷ lệ chốt hẹn', 'Chuẩn hoá kịch bản gọi', 'Phân data cho team'],
  'd-cskh': ['Gọi chăm sóc sau liệu trình', 'Xử lý khiếu nại khách hàng', 'Khảo sát mức độ hài lòng', 'Nhắc lịch hẹn tuần tới', 'Tổng hợp phản hồi Zalo'],
  'd-vh': ['Kiểm tra vật tư phòng điều trị', 'Sửa điều hoà phòng thủ thuật', 'Sắp xếp lịch KTV', 'Kiểm tra máy phát điện dự phòng', 'Chuẩn bị phòng VIP'],
  'd-it': ['Sửa lỗi đồng bộ POS', 'Cấu hình máy in hoá đơn', 'Nâng cấp module lịch hẹn', 'Sao lưu dữ liệu hệ thống', 'Phân quyền tài khoản mới', 'Tích hợp tổng đài CareSoft'],
};

// PRNG cố định để dữ liệu mẫu ổn định
function rng(seed: number) {
  let a = seed;
  return () => {
    a = (a + 0x6d2b79f5) | 0;
    let t = Math.imul(a ^ (a >>> 15), 1 | a);
    t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
}

const iso = (ymd: string, hour = 9) => dayjs(ymd).hour(hour).toISOString();

export function seedTasks(count = 460, days = 120): WorkTask[] {
  const r = rng(20261027);
  const pick = <T,>(arr: T[]) => arr[Math.floor(r() * arr.length)];
  const today = dayjs().startOf('day');
  const tasks: WorkTask[] = [];
  for (let i = 0; i < count; i++) {
    const project = pick(PROJECTS);
    // việc con theo phòng ban của việc cha: tên việc và người làm cùng phòng
    const parent = i > 20 && r() < 0.18 ? tasks[Math.floor(r() * tasks.length)] : undefined;
    const deptId = parent ? parent.departmentId : project.departmentId;
    const deptMembers = MEMBERS.filter(m => m.departmentId === deptId && m.id !== ME_ID);
    const created = today.subtract(Math.floor(Math.pow(r(), 0.8) * days), 'day');
    const due = r() > 0.14 ? created.add(2 + Math.floor(r() * 20), 'day') : null;
    const age = today.diff(created, 'day');
    const needReview = r() < 0.6;
    const roll = r();
    let status: TaskStatus;
    if (roll < Math.min(0.82, age / 40)) status = 'done';
    else if (roll > 0.975) status = 'failed';
    else if (needReview && roll > 0.9) status = 'review';
    else status = r() > 0.4 ? 'doing' : 'todo';
    let doneAt: string | undefined;
    if (status === 'done' || status === 'review') {
      const span = due ? due.diff(created, 'day') : 10;
      // phần lớn xong trước hạn, khoảng 1/4 trễ vài ngày
      const d = created.add(Math.max(0, Math.round(span * (r() < 0.75 ? r() : 1 + r() * 0.6))), 'day');
      doneAt = (d.isAfter(today) ? today : d).format('YYYY-MM-DD');
    }
    const creatorId = r() < 0.12 ? ME_ID : pick(deptMembers).id;
    const assigneeId = r() < 0.07 && status === 'todo' ? undefined : r() < 0.1 ? ME_ID : pick(r() < 0.95 ? deptMembers : MEMBERS.slice(1)).id;
    const createdAt = created.format('YYYY-MM-DD');
    const activity: TaskActivity[] = [{ id: `a${i}-1`, at: iso(createdAt, 8), by: creatorId, type: 'create' }];
    if (assigneeId) activity.push({ id: `a${i}-2`, at: iso(createdAt, 8), by: creatorId, type: 'assign', text: assigneeId });
    if (status !== 'todo') activity.push({ id: `a${i}-3`, at: iso(createdAt, 10), by: assigneeId ?? creatorId, type: 'start' });
    if (doneAt && needReview) activity.push({ id: `a${i}-4`, at: iso(doneAt, 16), by: assigneeId ?? creatorId, type: 'submit' });
    if (status === 'done') activity.push({ id: `a${i}-5`, at: iso(doneAt!, 17), by: needReview ? creatorId : assigneeId ?? creatorId, type: needReview ? 'approve' : 'submit' });
    if (status === 'failed') activity.push({ id: `a${i}-6`, at: iso(today.format('YYYY-MM-DD'), 8), by: creatorId, type: 'fail', text: 'Không đạt yêu cầu' });
    tasks.push({
      id: `wt-${i + 1}`,
      code: `CV-${1000 + i + 1}`,
      name: pick(TASK_NAMES[deptId]),
      projectId: parent ? parent.projectId : project.id,
      departmentId: deptId,
      parentId: parent?.id,
      creatorId,
      assigneeId,
      followerIds: [],
      createdAt,
      startAt: createdAt,
      dueAt: due?.format('YYYY-MM-DD'),
      submittedAt: needReview ? doneAt : undefined,
      doneAt: status === 'done' ? doneAt : undefined,
      status,
      important: r() < 0.35,
      urgent: r() < 0.25,
      needReview,
      activity,
    });
  }
  seedRoutines(tasks, today, r);
  return tasks;
}

/** Việc định kỳ theo mẫu quy trình: các lần đã qua đã đóng (phần lớn đúng hạn), lần hiện tại đang mở */
function seedRoutines(tasks: WorkTask[], today: dayjs.Dayjs, r: () => number) {
  const plan: [string, number][] = [['tpl-phanve', 21], ['tpl-khukhuan', 21], ['tpl-nhietdo', 21], ['tpl-chatthai', 8], ['tpl-laser', 3], ['tpl-handung', 3]];
  plan.forEach(([tplId, times]) => {
    const tpl = TEMPLATES.find(x => x.id === tplId);
    if (!tpl?.repeat) return;
    const unit = tpl.repeat === 'daily' ? 'day' : tpl.repeat === 'weekly' ? 'week' : 'month';
    const team = MEMBERS.filter(m => m.departmentId === tpl.departmentId && m.id !== ME_ID);
    const lead = team.find(m => m.manager === 'department') ?? team[0];
    for (let k = times - 1; k >= 0; k--) {
      const n = tasks.length + 1;
      const start = today.subtract(k, unit);
      const due = start.add(tpl.dueDays, 'day');
      const assigneeId = team[k % team.length].id;
      const roll = r();
      const status: TaskStatus = k === 0 ? 'todo' : roll < 0.95 ? 'done' : 'failed';
      const doneDay = status === 'done' ? (roll < 0.86 ? due : due.add(1, 'day')) : undefined;
      const doneAt = doneDay && (doneDay.isAfter(today) ? today : doneDay).format('YYYY-MM-DD');
      const createdAt = start.format('YYYY-MM-DD');
      const activity: TaskActivity[] = [
        { id: `a${n}-1`, at: iso(createdAt, 7), by: lead.id, type: 'create', text: k < times - 1 ? 'Tự tạo lần tiếp theo của việc định kỳ' : undefined },
        { id: `a${n}-2`, at: iso(createdAt, 7), by: lead.id, type: 'assign', text: assigneeId },
      ];
      if (doneAt) {
        activity.push({ id: `a${n}-3`, at: iso(doneAt, 17), by: assigneeId, type: 'submit' });
        if (tpl.needReview) activity.push({ id: `a${n}-4`, at: iso(doneAt, 18), by: lead.id, type: 'approve' });
      }
      if (status === 'failed') activity.push({ id: `a${n}-5`, at: iso(due.add(1, 'day').format('YYYY-MM-DD'), 8), by: lead.id, type: 'fail', text: 'Không thực hiện trong ca — đã nhắc nhở' });
      tasks.push({
        id: `wt-${n}`,
        code: `CV-${1000 + n}`,
        name: tpl.name,
        description: tpl.description,
        projectId: `t-${tpl.departmentId}`,
        departmentId: tpl.departmentId,
        creatorId: lead.id,
        assigneeId,
        followerIds: [],
        createdAt,
        startAt: createdAt,
        dueAt: due.format('YYYY-MM-DD'),
        submittedAt: doneAt,
        doneAt,
        status,
        important: !!tpl.important,
        urgent: !!tpl.urgent,
        needReview: tpl.needReview,
        needProof: tpl.needProof,
        repeat: tpl.repeat,
        seriesId: `series-${tpl.id}`,
        templateId: tpl.id,
        checklist: tpl.checklist.map((text, j) => ({ id: `wt-${n}-c${j}`, text, ...(doneAt ? { done: true, by: assigneeId, at: iso(doneAt, 16) } : {}) })),
        activity,
      });
    }
  });
}

export const departmentName = (id?: string) => DEPARTMENTS.find(d => d.id === id)?.name ?? '—';
export const projectOf = (id?: string) => PROJECTS.find(p => p.id === id);
export const memberOf = (id?: string) => MEMBERS.find(m => m.id === id);
export const memberName = (id?: string) => memberOf(id)?.name ?? 'Chưa giao';
